import { useContext, useEffect } from 'react';

import AnalyticsContext from '@/contexts/AnalyticsContext';

let pingInitialized = false;

export const useStepEvent = (pageName: string): void => {
  const analyticsService = useContext(AnalyticsContext);

  useEffect(() => {
    const setStep = async () => {
      const analytics = await analyticsService;
      if (!analytics) return;

      analytics.setPageName(pageName);

      if (!pingInitialized) {
        pingInitialized = true;
        analytics.initPing();
      }
    };

    setStep();
  }, [analyticsService, pageName]);
};
